import * as React from "react";
import { useState } from "react";
import { ChatConstants } from "../../constants/ChatConstants";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { ButtonPrimaryMedium } from "../generic/common/ButtonPrimaryMedium";
import { TextInput } from "../generic/text-input/TextInput";
import { TextLoca } from "../generic/text/TextLoca";
export var ChatMessageSend = React.memo(function (_a) {
    var onMessageSend = _a.onMessageSend;
    var _b = useState(""), newMessage = _b[0], setNewMessage = _b[1];
    var handleOnSend = function () {
        onMessageSend(newMessage);
        setNewMessage("");
    };
    var chatMessagePlaceholder = utilLoca.get(IdLoca.coopChat_maxCharacters_web);
    return (React.createElement(React.Fragment, null,
        React.createElement(TextInput, { style: IdStyles.CoopChatInput, placeholder: chatMessagePlaceholder, onChange: setNewMessage, value: newMessage, minLength: ChatConstants.MinimumTextCharacters, maxLength: ChatConstants.MaximumTextCharacters, onSubmit: handleOnSend }),
        React.createElement(ButtonPrimaryMedium, { onClick: handleOnSend },
            React.createElement(TextLoca, { id: IdLoca.send, className: IdStyles.TextButtonDefault }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/ChatMessageSend.tsx
// module id = 2577
// module chunks = 3